<template>
    <div id="error">
      <h2>{{ $t("message.error.title") }}</h2>
      <hr>
      <p>{{ $t("message.top.error." + this.$route.query.msg) }}</p>
    </div>
</template>

<script>
export default {
  name: 'Error'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Error.vue